import { render, staticRenderFns } from "./EventCardLarge.vue?vue&type=template&id=5cbb3aa0"
import script from "./EventCardLarge.vue?vue&type=script&lang=js"
export * from "./EventCardLarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports